<template>
  <div class="contact-row has-text-white columns is-vcentered">
    <div class="column">
      <div class="contact-item">
        <p class="contact-item__title">{{ office.name }}</p>
        <div class="contact-item__entry">
          <icon name="fa-map-marker-alt" />
          <p>{{ office.address }}</p>
          <p>{{ office.city }}</p>
        </div>
        <div class="contact-item__entry">
          <icon name="fa-clock" />
          <p>{{ days }}</p>
          <p>{{ hours }}</p>
          <p class="contact-item__entry__footer">{{ office.disclaimer }}</p>
        </div>
        <div
          class="contact-item__entry"
          v-for="{ phone, href } in phones"
          :key="phone"
        >
          <a
            :href="`tel:${href}`"
            class="button is-outlined is-white is-rounded is-fullwidth is-small-mobile"
          >
            <icon name="fa-phone-alt" />
            <span>{{ phone }}</span>
          </a>
        </div>
        <div class="contact-item__entry" v-for="mail in mails" :key="mail">
          <a
            :href="`mailto:${mail}`"
            class="button is-outlined is-white is-rounded is-fullwidth"
          >
            <icon name="fa-envelope" />
            <span>{{ mail }}</span>
          </a>
        </div>
      </div>
    </div>
    <div class="column">
      <div class="map-wrapper">
        <geo-map
          class="map"
          :location="{ ...office, desc: office.address }"
          :zoom="map.options.zoom"
          :max-zoom="map.options.maxZoom"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { Icon, GeoMap } from "%helpers";

export default {
  name: "contact-row",

  components: {
    Icon,
    GeoMap
  },

  props: {
    office: Object
  },

  data() {
    return {
      map: {
        options: {
          zoom: 19,
          maxZoom: 19
        }
      }
    };
  },

  computed: {
    phones() {
      return this.office.phones.map(phone => ({
        phone,
        href: phone.replace(/\D/g, "")
      }));
    },

    mails() {
      return this.office.mails.map(mail => mail.trim());
    },

    days() {
      return this.office.days.replace("-", "\u2013");
    },

    hours() {
      return this.office.hours.replace("-", "\u2013");
    }
  }
};
</script>

<style lang="scss" scoped>
.contact-row {
  margin-bottom: 5rem;

  .contact-item {
    font-family: $family-sans-serif;
    font-weight: 500;
    text-align: center;

    &__title {
      font-family: $family-sans-serif-wide;
      font-weight: 900;
      text-align: center;
      font-size: 1.5rem;
      user-select: none;
    }

    &__entry {
      margin: 1rem 0;

      &__footer {
        font-style: italic;
        font-family: $family-sans-serif-wide;
        font-weight: 400;
        width: 50%;
        margin: 0 auto;
      }
    }

    &:not(:last-child) {
      margin-bottom: 100px;
    }

    .button {
      display: block;
      max-width: 14rem;
      margin: 0 auto;
    }
  }

  .map-wrapper {
    padding: 0 1rem;

    @include widescreen {
      padding: 0 5rem;
    }

    .map {
      height: 15rem;
      z-index: 0;
      box-shadow: 0 0 11px 3px transparentize($black, 0.6);

      @include widescreen {
        height: 20rem;
      }
    }
  }
}
</style>
